import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { TrackExperimentExposure } from '#src/app/shared/components/tracking';

import { ToastCard } from '../components/ToastCard';
import { useUsSurgingPetitionToast } from '../hooks/useUsSurgingPetitionToast';

const UsSurgingPetitionToastInner: React.FC<EmptyProps> = () => {
	const { experiment, shouldRenderToast, petition, onDismiss, onCtaClick } = useUsSurgingPetitionToast();

	return (
		<>
			{/* Fires $exposure once for both arms (control included); no-ops on fallback/override. */}
			{experiment && <TrackExperimentExposure experiment={experiment} />}
			{shouldRenderToast && petition && (
				<ToastCard
					displayTitle={petition.displayTitle}
					photo={petition.photo}
					signatureCount={petition.signatureCount}
					onDismiss={onDismiss}
					onCtaClick={onCtaClick}
				/>
			)}
		</>
	);
};

/**
 * App-chrome-level entry for the US surging-petition toast. The session/experiment/storage-dependent
 * subtree renders client-only (guest pages are server-cached), mirroring `app/banner`.
 */
export const UsSurgingPetitionToast: React.FC<EmptyProps> = () => (
	<ClientRender>
		<UsSurgingPetitionToastInner />
	</ClientRender>
);
